import Swal from "sweetalert2";
import axios from "../../axios";
import {
  ADD_COUNTRY,
  DELETE_COUNTRY,
  DELETE_COUNTRY_IMAGE,
  GET_COUNTRYS,
  UPDATE_COUNTRY,
  GET_ACTIVE_COUNTRYS,
  UPDATE_COUNTRY_STATUS,
} from "../types";
import { setAlert } from "./alert";
import { getErrorMessage } from "../../helpers/ErrorMessage";

const buildFormData = (data) => {
  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    const value = data[key];
    if (value === null || value === undefined) return;
    if (key === 'image' || key === 'file') {
      if (Array.isArray(value) && value.length > 0) {
        if (value[0].originFileObj) {
          formData.append('file', value[0].originFileObj);
        } else if (value[0].url) {

        }
      }
      return;
    }

    // Append other fields
    formData.append(key, value);
  });

  return formData;
};

export const addCountry = (values) => async (dispatch) => {
  try {
    const config = {
      headers: { 'Content-Type': 'multipart/form-data' }
    };

    const formData = buildFormData(values);
    const res = await axios.post("country/add", formData, config);

    if (res.data.code === 1) {
      dispatch({ type: ADD_COUNTRY, payload: res.data.data });
      Swal.fire({
        title: "Success!",
        text: res.data.message || "Country added successfully",
        icon: "success",
      });
      dispatch(setAlert(res.data.message, "success"));
      return true;
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      return false;
    }
  } catch (err) {
    const errorMessage = getErrorMessage(err.response?.data) || err.message;
    dispatch(setAlert(errorMessage, "danger"));
    Swal.fire({ title: "Error!", text: errorMessage, icon: "error" });
    return false;
  }
};

export const updateCountry = (values) => async (dispatch) => {
  try {
    const config = {
      headers: { 'Content-Type': 'multipart/form-data' }
    };

    const formData = buildFormData(values);
    // Ensure ID is present
    if (!formData.has('id') && values.id) {
      formData.append('id', values.id);
    }

    const res = await axios.post("country/update", formData, config);

    if (res.data.code === 1) {
      dispatch({ type: UPDATE_COUNTRY, payload: res.data.data });
      Swal.fire({
        title: "Success!",
        text: res.data.message || "Country updated successfully",
        icon: "success",
      });
      dispatch(setAlert(res.data.message, "success"));
      return true;
    } else {
      const msg = res.data.message || "Update failed";
      dispatch(setAlert(msg, "warning"));
      Swal.fire({ title: "Warning!", text: msg, icon: "warning" });
      return false;
    }
  } catch (err) {
    const errorMessage = getErrorMessage(err.response?.data) || err.message;
    dispatch(setAlert(errorMessage, "danger"));
    Swal.fire({ title: "Error!", text: errorMessage, icon: "error" });
    return false;
  }
};

export const getCountries = () => async (dispatch) => {
  try {
    const res = await axios.get("country/all");
    if (res.data.code === 1) {
      dispatch({ type: GET_COUNTRYS, payload: res.data.data });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

export const getActiveCountries = () => async (dispatch) => {
  try {
    const res = await axios.get("country/get?status=1");
    if (res.data.code === 1) {
      dispatch({ type: GET_ACTIVE_COUNTRYS, payload: res.data.data });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

export const updateCountryStatus = (formData) => async (dispatch) => {
  try {

    const updatedFormData = {
      id: formData.id,
      ...(formData.status !== undefined && { status: formData.status }),
    };

    const res = await axios.post("country/update/status", updatedFormData);
    if (res.data.code === 1) {
      dispatch({ type: UPDATE_COUNTRY_STATUS, payload: res.data.data });
      Swal.fire({
        title: 'Success!',
        text: res.data.message,
        icon: 'success',
      });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: 'warning!',
        text: res.data.message,
        icon: 'warning',
      });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

export const deleteCountry = (id) => async (dispatch) => {
  try {
    if (!id) {
      dispatch(setAlert("Please select any record", "warning"));
      return false;
    }
    const res = await axios.post(`country/delete/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: DELETE_COUNTRY, payload: { id } });
      Swal.fire({
        title: "Success!",
        text: res.data.message,
        icon: "success",
      });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

export const deleteCountryImage = (id) => async (dispatch) => {
  try {
    if (!id) {
      dispatch(setAlert("Country ID is required", "warning"));
      return false;
    }
    const res = await axios.post(`country/delete/image/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: DELETE_COUNTRY_IMAGE, payload: { id } });
      Swal.fire({
        title: "Deleted!",
        text: res.data.message || "Image deleted successfully",
        icon: "success",
      });
      dispatch(setAlert(res.data.message, "success"));
      return true;
    } else {
      Swal.fire({
        title: "Warning!",
        text: res.data.message || "Could not delete image",
        icon: "warning",
      });
      dispatch(setAlert(res.data.message, "warning"));
      return false;
    }
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message;
    dispatch(setAlert(errorMessage, "danger"));
    Swal.fire({ title: "Error!", text: errorMessage, icon: "error" });
    return false;
  }
};
